<template>
  <v-content>
    <v-container fluid>
      <Header :title="'Inbox'" />
      <v-row no-gutters>
      <v-row v-if='Object.keys(currentUser).length !=0  && (currentUser.roles.includes(1) || currentUser.roles.includes(3))'>
        <v-col cols='12' md='4' sm='12'>
          <v-autocomplete
              v-model="selectedGroups"
              :items="groups"
              item-value="group_id"
              item-text="group_name"
              :label="'Groups' | translate"
              outlined
              autocomplete="off"
              chips
              small-chips
              multiple
              required
              :no-data-text="$t('No data available')"
              :disabled="(selectedUsers.length > 0? true : false)"
            >
            <template v-slot:prepend-item>
              <v-list-item>
                <v-checkbox @change="checkboxUpdated('groups')" v-model="checkAllGroups" label="All"></v-checkbox>
              </v-list-item>
            </template>  
            </v-autocomplete>
        </v-col> 
        <v-col cols='12' md='4' sm='12'>
          <v-autocomplete
              v-model="selectedUsers"
              :items="users"
              item-value="user_id"
              :item-text="item =>`${item.name} (${item.email})`"
              :label="'Users' | translate"
              outlined
              autocomplete="off"
              chips
              small-chips
              multiple
              required
              :no-data-text="$t('No data available')"
              :disabled="(selectedGroups.length > 0? true : false)"
            >
          <template v-slot:prepend-item>
            <v-list-item>
              <v-checkbox @change="checkboxUpdated('users')" v-model="checkAllUsers" label="All"></v-checkbox>
            </v-list-item>
          </template>            
            
            </v-autocomplete>
        </v-col>       
        <v-col cols='12' md='4' sm='12'>
          <v-row class="mt-n3">
            <v-col cols="12" md="6" sm="12">
              <v-btn class="white--text" small :color="primary_color" @click="getInboxData()"  x-large block>
                {{ 'Search' | translate }}
              </v-btn>
            </v-col>
            <v-col cols="12" md="6" sm="12">
              <v-btn class="white--text" small :color="primary_color" @click="clearFilter()"  x-large block>
                {{ 'Reset' | translate }}
              </v-btn>
            </v-col>
          </v-row>
             
        </v-col>
      </v-row> 
        <v-col cols="12">
        <v-tabs>
          <v-tab>{{ 'Items Board' | translate }}</v-tab>
          <v-tab>{{ 'Setup Items' | translate }}</v-tab>
          <v-tab-item>
            <DataTable v-if='!userdocuments.hasOwnProperty("stage_1") && !userdocuments.hasOwnProperty("stage_2")'  :title="title" :headers="headers" :items="userdocuments" :search="search" @openSettingsDialog='openSettingsDialog' />
            <DataTable v-if='userdocuments.hasOwnProperty("stage_1")' :title="userdocuments.hasOwnProperty('stage_1')? userdocuments.stage_1.set_name : ''" :headers="headers" :items="userdocuments.hasOwnProperty('stage_1')? userdocuments.stage_1.user_documents : []" :search="stage1search" @openSettingsDialog='openSettingsDialog' :settingsstatus='valid' />
            <br /><br />
            <DataTable v-if='userdocuments.hasOwnProperty("stage_2")' :title="userdocuments.hasOwnProperty('stage_2')? userdocuments.stage_2.set_name : ''" :headers="headers" :items="userdocuments.hasOwnProperty('stage_2')? userdocuments.stage_2.user_documents : []" :search="stage2search"  />
          </v-tab-item>
          <v-tab-item>
            <DataTable  :title="createdocumenttitle" :headers="createdocumentheaders" :items="createdocuments" :search="createsearch"  />
          </v-tab-item>

        </v-tabs> 

        <v-dialog v-model="settingsdialog" persistent max-width="600px">
          <v-card>
            <v-card-title>
              <span class="headline">{{ 'Set Filter'| translate }}</span>
            </v-card-title>
            <v-card-text>
              <v-container>
                <v-form id="form" ref="form">
                  <v-row>
                    <v-col cols="12" sm="12">
                      <h3 class="pb-4">{{ 'Stage 1'| translate }}</h3>
                      <v-divider></v-divider>
                    </v-col>
                    <v-col cols="12" md="6">
                    <v-text-field
                      :label="'Set Name' | translate"
                      v-model="set_name_stage_1"
                      :disabled="isUser"
                      :rules="stage1name"
                    >
                    <template #message="{ message }">
                      {{ (curLanguage.lang_code == 'en' ? message : $t(message))}}
                    </template>                     
                    </v-text-field>
                    </v-col>
                    <v-col cols="12" md="6">
                    <v-text-field
                      :label="'Show next' | translate"
                      v-model="due_days_stage_1"
                      :disabled="isUser"
                      type="number"
                      :rules="duedays1"
                    >
                    <template #message="{ message }">
                      {{ (curLanguage.lang_code == 'en' ? message : $t(message))}}
                    </template>                     
                    </v-text-field>
                    </v-col>
                  </v-row>
                  <v-row>
                    <v-col cols="12" sm="12">
                      <h3 class="pb-4">{{ 'Stage 2'| translate }}</h3>
                      <v-divider></v-divider>
                    </v-col>
                    <v-col cols="12" md="6">
                    <v-text-field
                      :label="'Set Name' | translate"
                      :disabled="isUser"
                      v-model="set_name_stage_2"
                      :rules="stage2name"
                    >
                    <template #message="{ message }">
                      {{ (curLanguage.lang_code == 'en' ? message : $t(message))}}
                    </template> 
                    </v-text-field>
                    </v-col>
                    <v-col cols="12" md="6">
                    <v-text-field
                      :label="'Show from' | translate"
                      :disabled="isUser"
                      v-model="due_days_stage_2"
                      :rules="duedays2"
                      type="number"
                    >
                    <template #message="{ message }">
                      {{ (curLanguage.lang_code == 'en' ? message : $t(message))}}
                    </template> 
                    </v-text-field>
                    </v-col>
                  </v-row>

                </v-form>
              </v-container>
            </v-card-text>
            <v-card-actions>
              <v-spacer></v-spacer>
              <v-btn color="blue darken-1" text @click="settingsdialog=false">{{ 'Close'| translate }}</v-btn>
              <v-btn color="blue darken-1" :disabled="isUser" text @click="clearsettings()">{{ 'Clear'| translate }}</v-btn>  
              <v-btn color="blue darken-1" :disabled="isUser" text @click="setFilter()">{{ 'Save'| translate }}</v-btn>              
            </v-card-actions>
          </v-card>
        </v-dialog>
        </v-col>
      </v-row>
    </v-container>
  </v-content>
</template>


<script>
import store from "@/store"
import { mapGetters } from "vuex"
import { FETCH_USER_DOCUMENTS, FETCH_USERS, FETCH_GROUPS, FETCH_CREATE_DOCUMENT, CLEAR_INBOX_SETTINGS,FETCH_INBOX_SETTINGS,SAVE_UPDATE_INBOX_SETTINGS } from "@/store/actions.type"
import { SET_LOADING, SET_ROUTER_ENTER } from "@/store/mutations.type"

export default {
  name: "Inbox",
  async beforeRouteEnter(to, from, next) {
    if (store.state.auth.user.roles.includes(1) || store.state.auth.user.roles.includes(3)) {
      Promise.all([
        store.dispatch(FETCH_GROUPS, ""),
        store.dispatch(FETCH_USERS, ''),
      ]).finally(()=>{
          store.commit(SET_LOADING, false)
                  
      })
    }
    Promise.all([
      await store.dispatch(FETCH_USER_DOCUMENTS,'?status=active'),
      await store.dispatch(FETCH_CREATE_DOCUMENT,'initialize')
    ]).finally(()=>{
        store.commit(SET_LOADING, false);
        store.commit(SET_ROUTER_ENTER, false)
    })

    return next();
  },
  data: function() {
    return {
      title: "Items Board",
      createdocumenttitle: 'Setup Items',
      search: "",
      createsearch: "",
      singleSelect: "",
      settingsdialog : false,
      set_name_stage_1: null,
      set_name_stage_2: null,
      due_days_stage_1: null,
      due_days_stage_2: null,
      stage1search: "",
      stage2search: "",
      valid: 'true',
      checkAllGroups: false,
      checkAllUsers: false, 
      selectedUsers: [],
      selectedGroups: [], 
      primary_color: '',
      isSearching: false,

          
    };
  },
  methods: {
    async getInboxData(){

    Promise.all([
      await store.dispatch(FETCH_USER_DOCUMENTS,'?status=active&user_ids='+this.selectedUsers+'&group_ids='+this.selectedGroups),
      await store.dispatch(FETCH_CREATE_DOCUMENT,'initialize?user_ids='+this.selectedUsers+'&group_ids='+this.selectedGroups)
    ]).finally(()=>{
        if(this.settingsdialog){
          this.set_name_stage_1 = ''
          this.due_days_stage_1  = ''
          this.set_name_stage_2 = ''
          this.due_days_stage_2 = ''                
          this.settingsdialog = false
          this.$refs.form.reset()
        }


        store.commit(SET_LOADING, false);
        store.commit(SET_ROUTER_ENTER, false)
    })
    },
    checkboxUpdated(flag){
      if(flag == "groups" && this.checkAllGroups){
          this.selectedGroups = []
          this.selectedGroups = this.groups.map(data=>data.group_id)
          this.selectedUsers = []
          this.checkAllUsers = false   
          this.changedGroup()
      }
      else if(flag=="groups" && this.checkAllGroups == false){
        this.selectedGroups = []
        this.selectedUsers = []
        this.checkAllUsers = false   
        this.changedGroup()
      }
      else if(flag == "users" && this.checkAllUsers){
        this.selectedUsers = []
        this.selectedUsers = this.users.map(data=>data.user_id)        
      }
      else if(flag== "users" && this.checkAllUsers == false){
        this.selectedUsers = []
      }

    },

    async clearFilter(){
      this.checkAllGroups = false
      this.checkAllUsers = false      
      this.selectedGroups = []
      this.selectedUsers = []
      await this.changedGroup()
      await this.getInboxData()
    },
    async openSettingsDialog(){
      await this.$store.dispatch(FETCH_INBOX_SETTINGS,'inbox').then( resp =>{
        if(resp.success){
          this.set_name_stage_1 = (this.inboxsettings.hasOwnProperty('setting_data')?this.inboxsettings.setting_data.stage_1.set_name : "")
          this.set_name_stage_2 = (this.inboxsettings.hasOwnProperty('setting_data')?this.inboxsettings.setting_data.stage_2.set_name : "")
          this.due_days_stage_1  = (this.inboxsettings.hasOwnProperty('setting_data')?this.inboxsettings.setting_data.stage_1.due_days : "")
          this.due_days_stage_2  = (this.inboxsettings.hasOwnProperty('setting_data')?this.inboxsettings.setting_data.stage_2.due_days : "")
          this.settingsdialog = true
          store.commit(SET_LOADING, false)
        }
      })      
    },
    closeSettingsDialog(){
      this.settingsdialog = false
      this.$refs.form.reset()      
      this.set_name_stage_1 = ''
      this.due_days_stage_1  = ''
      this.set_name_stage_2 = ''
      this.due_days_stage_2 = ''

    },
     clearsettings(){
     this.$store.dispatch(CLEAR_INBOX_SETTINGS,'inbox').then( async resp =>{
        if(resp.success){
            this.settingsdialog = false
            this.$refs.form.reset()                
            this.set_name_stage_1 = ''
            this.due_days_stage_1  = ''
            this.set_name_stage_2 = ''
            this.due_days_stage_2 = ''
            this.getInboxData()
        }
      })      
    },      

     setFilter(){
      if (this.$refs.form.validate()) {
         this.$store.dispatch(SAVE_UPDATE_INBOX_SETTINGS, {
          'stage_1':{ set_name: this.set_name_stage_1, due_days: this.due_days_stage_1 },
          'stage_2':{ set_name: this.set_name_stage_2, due_days: this.due_days_stage_2 }
        }).then(async resp => {
          if(resp != undefined && resp.hasOwnProperty('success') && resp.success){
            this.getInboxData()        
          }
          else{
            store.commit(SET_LOADING, false)
          }

        });

      }
    }
  },
  mounted(){
    let company_meta  = JSON.parse(this.currentUser.company.company_meta)
    this.primary_color  = company_meta.primary_color

    if(this.currentUser.roles.includes(4) == true  && this.currentUser.is_group_user == false){
      this.$router.push('/dashboard')
    }
  },  
  components: {
    DataTable: () => import("@/components/datatable/datatable"),
    Header: () => import("@/components/header/Header"),
  },
  computed: {
    ...mapGetters(["userdocuments","currentUser", 'users' ,'groups','createdocuments','inboxsettings','curLanguage']),
    headers(){ 
        return [
        { text: this.$t("Name"), value: "item_name" },   
        { text: this.$t("Template name"), value: "temp_name" },
        { text: this.$t("Type"), value: "temp_type" }, 
        { text: this.$t("Due date"), value: "due_date" },
        { text: this.$t("Days until"), value: "days_until" },
        { text: this.$t("Action"), value: "linktouser", sortable: false }
      ]
    },
    createdocumentheaders(){ 
        return [
        { text: this.$t("Name"), value: "item_name" },   
        { text: this.$t("Template name"), value: "temp_name" },
        { text: this.$t("Type"), value: "temp_type" }, 
        { text: this.$t("Due date"), value: "due_date" },
        { text: this.$t("Days until"), value: "days_until" },
        { text: this.$t("Action"), value: "createdocumentaction", sortable: false }
      ]
    },
    isUser(){
      return this.currentUser.roles.includes(1) && this.currentUser.roles.length == 1 ? false:true
    },     
    stage1name(){ return [v => !!v || "Name is required"]},
    stage2name(){ return [v => !!v || "Name is required"]},
    duedays1(){ return [v => !!v || "Due days is required"]},
    duedays2(){ return [v => !!v || "Due days is required"]},

  }
};
</script>